<template>
  <InfoModal
    v-model="modelValue"
    :title="i18n.global.t('pages.dashboard.overTime.title')"
    modalHeight="80%"
    slotTextAreaHeight="60%"
  >
    <template v-slot:text>
      <div class="h-100">
        <div class='d-flex justify-content-end'>
          <small class="p-3 fw-bold">
            {{ `${month} ${i18n.global.t('pages.dashboard.monthly')} (${props.start_date} ~ ${props.end_date}) ${i18n.global.t('pages.dashboard.displayData')}` }}
          </small>
        </div>
        <div
          class="row mx-1 dashbord-list"
          style="height: 95%"
        >
          <v-table
            class="h-100 px-0"
          >
            <thead>
              <tr>
                <th>
                  {{ i18n.global.t('pages.dashboard.driverName') }}
                </th>
                <th>
                  {{ i18n.global.t('pages.dashboard.overTime.monthlySummary') }}
                </th>
                <th>
                  {{ i18n.global.t('pages.dashboard.overTime.remainingTime') }}
                </th>
                <th>
                  {{ i18n.global.t('pages.dashboard.overTime.predictionMonthlySummary') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="props.details?.length">
                <tr
                  v-for="item in details"
                  :key="item.driver_id"
                  :class="getClass(
                    item.monthly_summary,
                    item.prediction_monthly_summary,
                    props.threshold_seconds
                  )"
                >
                  <td>
                    {{ item.last_name }} {{ item.first_name }}
                  </td>
                  <td class="summary">
                    {{ convertSecondsToHHmm(item.monthly_summary) }}
                  </td>
                  <td class="remaining">
                    {{ convertSecondsToHHmm(getRemainingTime(item.monthly_summary, props.threshold_seconds)) }}
                  </td>
                  <td class="prediction">
                    {{ convertSecondsToHHmm(item.prediction_monthly_summary) }}
                  </td>
                </tr>
              </template>
            </tbody>
          </v-table>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex justify-content-end m-3">
        <v-btn class="m-1 reset-btn" @click="modelValue = false">
          {{ i18n.global.t('common.closeBtn') }}
        </v-btn>
      </div>
    </template>
  </InfoModal>
</template>

<script setup lang="ts">
import InfoModal from "@/components/Common/InfoModal.vue"
import { computed } from 'vue'
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue'])
const props = defineProps<{
  modelValue: boolean,
  start_date: string,
  end_date: string,
  details: any[],
  threshold_seconds: number,
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

const month = computed(() => {
  return new Date(props.end_date).getMonth() + 1
})

const convertSecondsToHHmm = computed(() => (seconds: number) => {
  let hour = Math.floor(seconds / 3600);
  let minutes: string | number = Math.floor(seconds % 3600 / 60);
  if (minutes < 10) minutes = '0' + minutes;

  return (hour + ':' + minutes);
})

function getClass(summary, prediction_monthly_summary, threshold) {
  let ret = ""
  if (threshold == 0) return ret
  if (summary >= threshold) ret += "overThresholdSummary "
  if (prediction_monthly_summary >= threshold) ret += "overThresholdPrediction "
  return ret
}

function getRemainingTime(summary, threshold) {
  const remaining = threshold - summary
  if (remaining < 0) return 0
  return remaining
}
</script>

<style scoped>
.overThresholdPrediction>.prediction{
  color: red;
}
.overThresholdSummary>.summary{
  color: red;
}
.overThresholdSummary>.remaining{
  color: red;
}
</style>
